module.exports = __webpack_public_path__ + "fonts/iconfont.7dc0e24f.woff";